 import React from 'react'
 import styles from './FooterStyles.module.css'



 export const PrivacyPolicy = () => {

  return (
   <>
     <div className={styles.Privacy_Main_Div}>
          <div>
        <h1 className={styles.Privacy_h1}> 
           Privacy Policy for IdeaKart
        </h1>
     <p>
         At www.ideakart.com we consider the privacy of our visitors to be extremely important.
         This privacy policy document describes in detail the types of personal
         information is collected and recorded by www.ideakart.com and how we use it.
     </p>
     <p className={styles.mainP}>
            Log Files 
     </p>
     <p>
            Like many other Web sites, www.ideakart.com makes use of log files. These files merely
            logs visitors to the site - usually a standard procedure for hosting companies and 
            a part of hosting services's analytics. The information inside the log files includes 
            internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), 
            date/time stamp, referring/exit pages, and possibly the number of clicks. This information 
            is used to analyze trends, administer the site, track user's movement around the site,
            and gather demographic information. IP addresses, and other such 
            information are not linked to any information that is personally identifiable.
     </p>
     <p className={styles.mainP}>
            Cookies and Web Beacons
     </p>
     <p>
            www.ideakart.com uses cookies to store information about visitors' preferences, 
            to record user-specific information on which pages the site visitor accesses or visits,
            and to personalize or customize our web page content based upon visitors'
            browser type or other information that the visitor sends via their browser.
     </p>
     <p className={styles.mainP}>
            DoubleClick DART Cookie
     </p>
     <p>
            → Google, as a third party vendor, uses cookies to serve ads on www.ideakart.com.
     </p>
     <p>
            → Google's use of the DART cookie enables it to serve ads to our site's visitors based 
            upon their visit to www.ideakart.com and other sites on the Internet.
     </p>
     <p>
            → Users may opt out of the use of the DART cookie by visiting the Google 
            ad and content network privacy policy at the following URL -
     </p>
     <p>
            http://www.google.com/privacy_ads.html
     </p>
     <p className={styles.mainP}>
             Our Advertising Partners
     </p>
     <p>
            Some of our advertising partners may use cookies and web beacons
            on our site. Our advertising partners include .......
     </p>
        
        <ul>
            <li>
               Google
            </li>
            <li>
              Amazon
            </li>
        </ul>
     <p>
        You may consult this listing to find the privacy policy for each of the advertising 
        partners of www.ideakart.com.
     </p>
     <p>
            These third-party ad servers or ad networks use technology in their respective advertisements 
            and links that appear on www.ideakart.com and which are sent directly to your browser. They
            automatically receive your IP address when this occurs. Other technologies (such as cookies, 
            JavaScript, or Web Beacons) may also be used by our site's third-party ad networks to measure 
            the effectiveness of their advertising campaigns and/or to personalize the advertising
            content that you see on the site.
     </p>
     <p>
            www.ideakart.com has no access to or control over these cookies that are used by third-party 
            advertisers.
     </p>
     <p className={styles.mainP}>
            Third Party Privacy Policies
     </p>
     <p>
            You should consult the respective privacy policies of these third-party ad servers for more 
            detailed information on their practices as well as for instructions about how to opt-out of 
            certain practices. www.ideakart.com's privacy policy does not apply to, 
            and we cannot control the activities of, such other advertisers or web sites.
     </p>
     <p>
            If you wish to disable cookies, you may do so through your individual browser options.
            More detailed information about cookie management with specific web browsers can be
            found at the browsers' respective websites.
     </p>
     <p className={styles.mainP}>
            Children's Information
     </p>
     <p>
            We believe it is important to provide added protection for children online. We encourage 
            parents and guardians to spend time online with their children to observe, participate in
            and/or monitor and guide their online activity. www.ideakart.com does not knowingly collect 
            any personally identifiable information from children under the age of 13. If a parent
            or guardian believes that www.ideakart.com has in its database the personally-identifiable
            information of a child under the age of 13, please contact us immediately (using the
            contact in the first paragraph) and we will use our best efforts to promptly remove such 
            information from our record
     </p>
     <p className={styles.mainP}>
            Online Privacy Policy Only
     </p>
     <p>
            This privacy policy applies only to our online activities and is valid for visitors
            to our website and regarding information shared and/or collected there. This policy
            does not apply to any information collected offline or via channels other than this
            website.
     </p>
     <p className={styles.mainP}>
            Consent
     </p>
     <p>
            By using our website, you hereby consent to our privacy policy and agree to its terms.
     </p>
          </div>

     </div>
           
                       {/* here im importing footer  */}

          
   </>
  )
}

